export enum EqualisationSection {
  Commitments = 'Commitments',
  Investments = 'Investments',
  Expenses = 'Expenses',
  Income = 'Income',
  ManagementFees = 'ManagementFees',
  GeneralCapitalCalls = 'GeneralCapitalCalls',
  ActionLinkedCapitalActions = 'ActionLinkedCapitalActions',
  EqualisationInterest = 'EqualisationInterest',
  Summary = 'Summary',
}

export enum FeesEqualisationTreatment {
  Full = 'full',
  Partial = 'partial',
  None = 'none',
}
